import { Anchor, Button, Center, Group, Paper, Stack, Text, Title } from '@mantine/core'
import { useAdminAuth } from '../auth/AdminAuthProvider'

/**
 * Deliberately explicit rather than a blank page. Someone landing here is far
 * more likely to be an admin whose claim has not propagated than an intruder,
 * and telling them nothing helps neither. It leaks nothing either: the domain
 * is discoverable via DNS regardless, and the real boundary is in the rules.
 */
export default function NotAuthorised() {
  const { state, signOutNow } = useAdminAuth()
  const email = state.status === 'not-authorised' ? state.user.email : null

  return (
    <Center mih="100vh" p="md">
      <Paper withBorder p="xl" w={460} maw="100%">
        <Stack gap="xs">
          <Text size="xs" c="dimmed" tt="uppercase" fw={600} style={{ letterSpacing: '0.08em' }}>
            RaceDash Admin
          </Text>
          <Title order={1} size="h3">
            Not authorised
          </Title>
          <Text c="dimmed" size="sm">
            {email ? <strong>{email}</strong> : 'This account'} is signed in but does not have
            platform administrator access.
          </Text>
          <Text c="dimmed" size="xs">
            If access was granted just now, sign out and back in — the permission travels in your
            sign-in token and only appears once that is reissued.
          </Text>
          <Group mt="md">
            <Button variant="default" onClick={() => void signOutNow()}>
              Sign out
            </Button>
            <Anchor href="https://app.racedash.live" size="sm">
              Go to the app
            </Anchor>
          </Group>
        </Stack>
      </Paper>
    </Center>
  )
}
